import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { ProductSizeInterface } from '../../../../../Interface/ProductSize';
import InfoButton from '../../Abstracts/InfoButton/InfoButton';
import ProductSizeInformation from '../../Abstracts/ProductSizeInformation/ProductSizeInformation';
import FavoriteButton from '../../Abstracts/FavoriteButton/FavoriteButton';
import ProductSizePrice from '../../Abstracts/ProductSizePrice/ProductSizePrice';

export default function ProductDetailsRow({
  product_size,
  onUpdate,
}: {
  product_size: ProductSizeInterface;
  onUpdate?: () => void;
}) {
  return (
    <Row className="d-none d-lg-flex">
      <Col>
        <ProductSizeInformation product_size={product_size} />
      </Col>
      <Col className="d-flex align-items-end justify-content-center">
        {product_size.has_productInfo && (
          <div className="mx-2">
            <InfoButton product_size={product_size} />
          </div>
        )}
        {product_size.is_favourite_allowed && (
          <div className="mx-2">
            <FavoriteButton
              key={`${product_size.erp_id}-${product_size.is_favourite}`}
              erp_id={product_size.erp_id}
              is_favorite={product_size.is_favourite}
              onUpdate={onUpdate}
            />
          </div>
        )}
      </Col>
      <Col
        lg={3}
        xl={2}
        className="d-flex flex-column align-items-end justify-content-end"
      >
        <ProductSizePrice product_size={product_size} />
      </Col>
    </Row>
  );
}
